import { useEffect, useMemo, useState } from "react";

export function useTelegram() {
  const [ready, setReady] = useState(false);
  const tg = useMemo(() => window.Telegram?.WebApp || null, []);

  useEffect(() => {
    tg?.ready();
    tg?.expand();
    tg?.enableClosingConfirmation();
    setReady(true);
  }, [tg]);

  return {
    ready,
    tg,
    user: tg?.initDataUnsafe?.user || { id: 0, first_name: "Creator", username: "demo" },
    initData: tg?.initData || "",
    haptic: (type = "light") => tg?.HapticFeedback?.impactOccurred(type),
    showToast: (message) => tg?.showPopup ? tg.showPopup({ title: "BotMaker", message }) : alert(message)
  };
}
